import $ from 'jquery';

export class PortalUtility {
	scrollToTop() {
		$(".page-host").animate({ scrollTop: 0 }, "fast");
	}
}
